var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.583c0 1.1-.257 2.153-.75 3.167a7.078 7.078 0 01-2.607 2.879 6.782 6.782 0 01-3.726 1.038c-1.1 0-2.153-.24-3.167-.734L2.5 17.5l1.583-4.75c-.493-1.014-.75-2.066-.75-3.167a6.783 6.783 0 011.038-3.726A7.078 7.078 0 017.25 3.25c1.014-.493 2.066-.75 3.167-.75h.416c1.738.096 3.38.83 4.609 2.058A7.068 7.068 0 0117.5 9.167v.416z",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFeedbackMenu;